import { LayoutModule } from '../../layout/modules';
import { UserFilters } from './filters';
import UserList from './list';
import { useState } from 'react';
import { USERNEW } from '../../../routes/paths';
import { UserFilter } from '../../../shared/types/user';

export const Users = () => {
    const [filters, setFilters] = useState<UserFilter>();

    return (
        <>
            <LayoutModule title="Listado usuarios" createPath={USERNEW}>
                <UserFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <UserList filters={filters} />
        </>
    );
};
